<script lang="ts">
  import { InfoCircleSolid } from "@getprovi/craft-svelte-icons";
  import { Icon } from "@getprovi/craft-svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import {
    ProductEntity,
    DistributorEntity,
    MinimumOrderQuantityEntity,
  } from "@shared/services/event_tracking/entities";

  import type { MinimumOrderQuantity } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";

  export let minimumOrderQuantity: MinimumOrderQuantity;
  export let sku: string;
  export let productId: number;
  export let distributorId: number;

  const { trackMrcEvents } = EventTracking;
  const trackingParams = [
    new ProductEntity({ productId }),
    new DistributorEntity({ id: distributorId }),
    new MinimumOrderQuantityEntity({
      label: minimumOrderQuantity.label,
      units: minimumOrderQuantity.units,
      cases: minimumOrderQuantity.cases,
      sleeves: minimumOrderQuantity.sleeves,
      sku: sku,
      messaging_type: "error_message",
    }),
  ];
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <div
    class="fizz-flex-row fizz-text-small fizz-text-negative align-left"
    data-testid="minimum-order-quantity-error-message"
    use:trackMrcEvents={[trackingContext.entities]}
  >
    <Icon iconName={InfoCircleSolid} size="icon-base" class="fizz-inline-4" />
    <span class="fizz-inline-4">Quantity is below minimum.</span>
  </div>
</TrackingContext>
